import React from "react";

const labelStyle: React.CSSProperties = {
  marginBottom: "0.5rem",
  fontWeight: "600",
  display: "block",
};

export interface ModalSearchSelectFieldProps {
  label: string;
  children: React.ReactNode;
}

/**
 * Wrapper for search-and-select fields (e.g. OrganisatieSelector, PersoonSelector).
 * Provides consistent label styling. The actual search/select UI is passed as children.
 */
export function ModalSearchSelectField({
  label,
  children,
}: ModalSearchSelectFieldProps) {
  return (
    <div className="modal-field">
      <label style={labelStyle}>{label}</label>
      {children}
    </div>
  );
}
